"use strict";
(self["webpackChunkapp451"] = self["webpackChunkapp451"] || []).push([[132],{

/***/ 15132:
/***/ ((module) => {

module.exports = /*#__PURE__*/JSON.parse('{"navigation":{"menu":"Menu"},"footer":{"privacyPolicy":"Privacy Policy"},"socialNetworks":{"connectWith":"Connect with {{network}}"}}');

/***/ })

}]);